import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
const sections = [{
  id: 'cover',
  number: '01',
  name: 'Identity'
}, {
  id: 'typography',
  number: '02',
  name: 'Typography'
}, {
  id: 'color',
  number: '03',
  name: 'Color'
}, {
  id: 'graphic',
  number: '04',
  name: 'Graphic Style'
}, {
  id: 'iconography',
  number: '05',
  name: 'Iconography'
}, {
  id: 'messaging',
  number: '06',
  name: 'Messaging'
}, {
  id: 'application',
  number: '07',
  name: 'Application'
}, {
  id: 'templates',
  number: '08',
  name: 'Templates'
}, {
  id: 'operations',
  number: '09',
  name: 'Operations'
}, {
  id: 'website',
  number: '10',
  name: 'Website'
}, {
  id: 'posters',
  number: '11',
  name: 'Posters'
}];
export function SectionNav() {
  const [activeSection, setActiveSection] = useState('cover');
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 200;
      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i].id);
        if (section && section.offsetTop <= scrollPosition) {
          setActiveSection(sections[i].id);
          break;
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 100,
        behavior: 'smooth'
      });
    }
  };
  return <nav className="fixed left-8 top-1/2 -translate-y-1/2 z-50 hidden lg:block" data-id="element-1589">
      <div className="space-y-6" data-id="element-1590">
        {sections.map(section => <button key={section.id} onClick={() => scrollToSection(section.id)} className="group flex items-center gap-3 text-left transition-all" data-id="element-1591">
            <span className={`font-mono text-xs transition-all ${activeSection === section.id ? 'text-[var(--accent-blue)] font-medium' : 'text-[var(--text-muted)]'}`} data-id="element-1592">
              {section.number}
            </span>
            <div className="flex items-center gap-2" data-id="element-1593">
              <div className={`h-px transition-all ${activeSection === section.id ? 'w-8 bg-[var(--accent-blue)]' : 'w-4 bg-[var(--divider)]'}`} data-id="element-1594" />
              <span className={`text-xs transition-all whitespace-nowrap ${activeSection === section.id ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-2 group-hover:opacity-60 group-hover:translate-x-0'}`} data-id="element-1595">
                {section.name}
              </span>
            </div>
          </button>)}
      </div>
    </nav>;
}